import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function Loader({ height, color }) {
  return (
    <div className="Loader" style={{ height }}>
      <svg className={`Loader__circle--${color}`} viewBox="25 25 50 50">
        <circle
          className="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    </div>
  );
}

Loader.propTypes = {
  height: PropTypes.string,
  color: PropTypes.oneOf(['black', 'gold', 'grey']),
};

Loader.defaultProps = {
  height: '150px',
  color: 'gold',
};
